<template>
	<div id="header" class="cookies_agreement" v-show="is_show">
		<div class="cookies_agreement_content">
			<div class="cookies_agreement_title">🍪 Файлы cookies</div>
			<div class="cookies_agreement_text">
				<p>
					Продолжая, вы подтверждаете использование файлов
					<router-link :to="{name: 'cookies_policy'}">cookies</router-link>
					браузера в целях обеспечения удобного функционирования сайта.
				</p>
			</div>
			<button @click="acceptCookies" class="cookies_agreement_btn">
				ПРИНЯТЬ
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "CookiesAgreementComponent",
	data() {
		return {
			is_show: true,
		}
	},
	mounted() {
		if (this.$cookies.get('cookies_agreement') === 'true') {
			this.is_show = false
		}
	},
	methods: {
		acceptCookies() {
			this.is_show = false
			this.$cookies.set('cookies_agreement', 'true', '12m')
		},
	},
}
</script>

<style scoped>
.cookies_agreement {
	background-color: #F7F3ED;
	position: fixed;
	width: calc(100% - 2em);
	max-width: 560px;
	height: auto;
	bottom: 1em;
	right: 1em;
	display: flex;
	align-content: center;
	justify-content: center;
	align-items: center;
	padding: 1.5em;
	border-radius: 1em;
	font-size: 0.85em;
	z-index: 999999;
	box-shadow: 0px 0px 20px rgba(44, 51, 51, 0.1);
	border: 1px solid #D9D2C5;
}

.cookies_agreement_content {
	width: 100%;
}

.cookies_agreement_title {
	font-weight: bold;
	font-size: 1.1em;
	margin-bottom: 0.8em;
	color: #2C3333;
}

.cookies_agreement_text {
	margin-bottom: 0.8em;
}

.cookies_agreement_text p {
	margin: 0 0 0.7em 0;
	line-height: 1.5;
	color: #333333;
}

.cookies_agreement_text a {
	color: #8B7355;
	text-decoration: underline;
}

.cookies_agreement_text a:hover {
	text-decoration: none;
	color: #2C3333;
}

.cookies_agreement_btn {
	padding: 0.5em 1em;
	background-color: #A39171;
	color: #333333;
	border: none;
	border-radius: 0.5em;
	font-size: 1em;
	cursor: pointer;
	font-weight: 500;
	letter-spacing: 0.1em;
	transition: background-color 0.3s ease;
}

.cookies_agreement_btn:hover {
	background-color: #2C3333;
}

@media (max-width: 567px) {
	.cookies_agreement {
		padding: 1em;
	}
}
</style>